// import { setConfig } from '../helpers/set_config.helper'
import axios from 'axios'
import { getValidConfig } from '../helpers/tokenManager.helper'

const ALL_PROFESSIONALS = 'Todos'

function professionalQuery (professional, separator = '?') {
  if (!professional || professional === ALL_PROFESSIONALS) return ''
  return `${separator}professional=${encodeURIComponent(professional)}`
}

export async function findeEscapedPatients (admin, token, dateRange, clientId, location, professional) {
  const config = await getValidConfig(admin, token)
  return await axios.patch(`${process.env.REACT_APP_CONFIRMATION_API}stats/escaped-patients`, {
    dateRange,
    clientId,
    location,
    professional
  }, config)
}

export async function findUsersNotReturned (admin, token, range, clientId, location, professional, page) {
  const config = await getValidConfig(admin, token)
  return await axios.put(`${process.env.REACT_APP_CONFIRMATION_API}stats/not-returned?page=${page}`, {
    range,
    clientId,
    location,
    professional
  }, config)
}

export async function getConfirmationsByClientAndDate (admin, token, dates, clientId, location, professional) {
  const config = await getValidConfig(admin, token)
  const url = `${process.env.REACT_APP_CONFIRMATION_API}stats/${dates}/${clientId}/${location}${professionalQuery(professional)}`
  return await axios.get(url, config)
}

export async function getConfirmationsUserByClientAndDate (admin, token, dates, clientId, location, professional) {
  const config = await getValidConfig(admin, token)
  const url = `${process.env.REACT_APP_CONFIRMATION_API}stats/user/${dates}/${clientId}?location=${encodeURIComponent(location)}${professionalQuery(professional, '&')}`
  return await axios.get(url, config)
}

export async function getConfirmationsUserStatistics (admin, token, dates, clientId, location, professional) {
  const config = await getValidConfig(admin, token)
  const url = `${process.env.REACT_APP_CONFIRMATION_API}stats/user-counter/${dates}/${clientId}/${location}${professionalQuery(professional)}`
  return await axios.get(url, config)
}

export async function getFirstConfirmationRange (admin, token, clientId, location) {
  const config = await getValidConfig(admin, token)
  return await axios.get(`${process.env.REACT_APP_CONFIRMATION_API}stats/${clientId}/${location}`, config)
}

export async function getPercentageByClientAndDate (admin, token, data) {
  const config = await getValidConfig(admin, token)
  return await axios.put(`${process.env.REACT_APP_CONFIRMATION_API}stats/percentage`, data, config)
}

export async function getLocationsByClient (admin, token, clientId, professional, dates) {
  const config = await getValidConfig(admin, token)
  const url = `${process.env.REACT_APP_CONFIRMATION_API}stats/locations?clientId=${clientId}&dates=${dates}${professionalQuery(professional, '&')}`
  return await axios.get(url, config)
}

export async function getProfessionalsByClient (admin, token, clientId, location, dates) {
  const config = await getValidConfig(admin, token)
  const url = `${process.env.REACT_APP_CONFIRMATION_API}stats/professionals?clientId=${clientId}&location=${encodeURIComponent(location)}&dates=${dates}`
  return await axios.get(url, config)
}
